import { createSlice } from "@reduxjs/toolkit";

export interface LoadingState {
  loading: boolean;
}
const initialState: LoadingState = {
  loading: false,
};
const loadingSlice = createSlice({
  name: "loading",
  initialState: initialState,
  reducers: {
    showLoader: (state) => {
      state.loading = true;
    },
    hideLoader: (state) => {
      state.loading = false;
    },
  },
});

export default loadingSlice.reducer;
export const { showLoader, hideLoader } = loadingSlice.actions;
